import Swiper from "swiper/bundle";
import "swiper/css/bundle";
/**
 * Layout: Hotel - Overview
 * Slug: hotel_overview
 */

document.addEventListener('DOMContentLoaded', function() {
    const layouts = document.querySelectorAll('.flex-layout.hotel_overview-layout');

	layouts.forEach((layout) => {
		const items = layout.querySelectorAll('.pk-accordion-item');

		items.forEach((item) => {
			const sliderContainer = item.querySelector('.swiper-container');
			if (!sliderContainer) return;

			let swiper = null;

			function initSlider() {
				// Guard against re-initializing an already-created Swiper
				// instance (e.g. closing/reopening the same item).
				if (swiper) return;

				const prevEl = sliderContainer.querySelector('.swiper-nav-prev');
				const nextEl = sliderContainer.querySelector('.swiper-nav-next');

				swiper = new Swiper(sliderContainer, {
					slidesPerView: 1,
					effect: 'fade',
					fadeEffect: {
						crossFade: true,
					},
					navigation: {
						prevEl,
						nextEl,
					},
				});
			}

			// `data-single-active` marks the first item "active" on initial
			// render, so its slider still needs to be initialized upfront.
			if (item.classList.contains('active')) {
				initSlider();
			}

			// The shared accordion.js (assets/js/accordion.js) toggles the
			// "active" class on open/close; observe that instead of
			// duplicating a click listener, so the slider only inits the
			// first time its own item is opened rather than all at once.
			const observer = new MutationObserver(() => {
				if (item.classList.contains('active')) {
					initSlider();
				}
			});

			observer.observe(item, { attributes: true, attributeFilter: ['class'] });
		});
	});
});
